import { irrigationPressure } from 'utils/unitConverter/by-domain/irrigationPressure'
import { almondBloom } from './by-domain/almondBloom'
import { almondHullSplit } from './by-domain/almondHullSplit'
import { alternaria } from './by-domain/alternaria'
import { beeHours } from './by-domain/beeHours'
import { cherryPowderyMildew } from './by-domain/cherryPowderyMildew'
import { chill } from './by-domain/chill'
import { cropDegreeDays } from './by-domain/cropDegreeDays'
import { dewPoint } from './by-domain/dewPoint'
import { emitterFlowRate } from './by-domain/emitterFlowRate'
import { emitterSpacing } from './by-domain/emitterSpacing'
import { evapotranspiration } from './by-domain/evapotranspiration'
import { fertigation } from './by-domain/fertigation'
import { fertigationVolume } from './by-domain/fertigationVolume'
import { fireBlight } from './by-domain/fireBlight'
import { flowMeter } from './by-domain/flowMeter'
import { fruitGrowth } from './by-domain/fruitGrowth'
import { grapePowderyMildew } from './by-domain/grapePowderyMildew'
import { humidity } from './by-domain/humidity'
import { insectDegreeDays } from './by-domain/insectDegreeDays'
import { insectLarvalTrend } from './by-domain/insectLarvalTrend'
import { insectPhenology } from './by-domain/insectPhenology'
import { insectTrapCatches } from './by-domain/insectTrapCatches'
import { irrigationActivity } from './by-domain/irrigationActivity'
import { irrigationApplicationRate } from './by-domain/irrigationApplicationRate'
import { leafWetness } from './by-domain/leafWetness'
import { plantStress } from './by-domain/plantStress'
import { precipitation } from './by-domain/precipitation'
import { rowSpacing } from './by-domain/rowSpacing'
import { soil } from './by-domain/soil'
import { temperature } from './by-domain/temperature'
import { walnutBlight } from './by-domain/walnutBlight'
import { wetBulb } from './by-domain/wetBulb'
import { wind } from './by-domain/wind'
import { windMachine } from './by-domain/windMachine'

export const unitConverter = {
  ...almondBloom,
  ...almondHullSplit,
  ...alternaria,
  ...beeHours,
  ...cherryPowderyMildew,
  ...chill,
  ...cropDegreeDays,
  ...dewPoint,
  ...emitterFlowRate,
  ...emitterSpacing,
  ...evapotranspiration,
  ...fertigation,
  ...fertigationVolume,
  ...fireBlight,
  ...flowMeter,
  ...fruitGrowth,
  ...grapePowderyMildew,
  ...humidity,
  ...insectDegreeDays,
  ...insectLarvalTrend,
  ...insectPhenology,
  ...insectTrapCatches,
  ...irrigationActivity,
  ...irrigationApplicationRate,
  ...irrigationPressure,
  ...leafWetness,
  ...plantStress,
  ...precipitation,
  ...rowSpacing,
  ...soil,
  ...temperature,
  ...walnutBlight,
  ...wetBulb,
  ...wind,
  ...windMachine,
}

export type TUnitConverterFunction = (typeof unitConverter)[keyof typeof unitConverter]
